import React from 'react';
import { Card, Tabs, Typography } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import LoginPoliciesTab from './tabs/LoginPoliciesTab';
import RegisteredDevicesTab from './tabs/RegisteredDevicesTab';
import DeviceAssignmentTab from './tabs/DeviceAssignmentTab';
import OfficeIpWhitelistTab from './tabs/OfficeIpWhitelistTab';
import AuditTrailTab from './tabs/AuditTrailTab';

const { Title } = Typography;

// Security → Login Policy Engine admin. Mutations are approval-gated + audited
// by the backend; approval templates are configured in the existing Approval
// Templates screen (entity types: LOGIN_POLICY, DEVICE_REGISTRATION, …).
// ?tab=devices|assignment|ips lets approval deep links land on the tab that owns
// the change being approved.
const SECURITY_TABS = ['policies', 'devices', 'assignment', 'ips', 'audit'];

const SecurityPage = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  return (
    <Card>
      <Title level={4}><SafetyOutlined /> Security — Login Policy Engine</Title>
      <Tabs
        defaultActiveKey={SECURITY_TABS.includes(tab) ? tab : 'policies'}
        items={[
          { key: 'policies', label: 'Login Policies', children: <LoginPoliciesTab /> },
          { key: 'devices', label: 'Registered Devices', children: <RegisteredDevicesTab /> },
          { key: 'assignment', label: 'Device Assignment', children: <DeviceAssignmentTab /> },
          { key: 'ips', label: 'Office IP Whitelist', children: <OfficeIpWhitelistTab /> },
          { key: 'audit', label: 'Audit Trail', children: <AuditTrailTab /> },
        ]}
      />
    </Card>
  );
};

export default SecurityPage;
